import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorList } from '../controls/error-prompt/error-list.model';
// import { NgForm } from '@angular/forms';
import { GenericList, GenericListItem } from './generic-list.model';


@Component({
    selector: 'app-generic-list-selector',
    templateUrl: './generic-list-selector.component.html',
    styleUrls: ['./generic-list-selector.component.css'],
})


export class GenericListSelectorComponent implements OnInit, OnDestroy {
    dialogRef: MatDialogRef<GenericListSelectorComponent>;


    // field refs
    // @ViewChild('Select', { read: ElementRef }) select: ElementRef;
    // @ViewChild('FromPeriod', { read: ElementRef }) fromPeriod: ElementRef;
    // @ViewChild('ToPeriod', { read: ElementRef }) toPeriod: ElementRef;
    // @ViewChild('UpdateDisplay', { read: ElementRef }) updateDisplay: ElementRef;

    // grid
    gridDataExists = true;
    selectAll = true;
    dataSource: MatTableDataSource<GenericListItem[]>;
    gridColumns: string[] = ['TextField']; // , 'Period', 'TermCode', 'SubjectCode', 'Section', 'AbbreviatedTitle', 'TeacherName', 'StudentCount', 'DaysGroupDescription'];
    DialogTitle: string;
    ColumnHeader: string;
    OKButtonLabel = 'OK';
    GridData: GenericListItem[] = [];
    errors: ErrorList[] = [];
    list: GenericList;

    // enums


    constructor(
        private dialog: MatDialog,
        GenericListSelectorDialogRef: MatDialogRef<GenericListSelectorComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.dialogRef = GenericListSelectorDialogRef;
        // console.log(this.data.Items);
        this.list = this.data;
        for (let x = 0; x < this.list.Items.length; x++) {
            this.GridData.push(this.list.Items[x]);
        }
        // console.log(this.GridData);
        this.dataSource = new MatTableDataSource(this.data.Items);

        this.DialogTitle = this.data.DialogTitle;
        this.ColumnHeader = this.data.ColumnHeader;

        if (this.list.OKButtonLabel) {
            this.OKButtonLabel = this.list.OKButtonLabel;
        }
    }

    ngOnInit() {
        // console.log(this.data);
        // this.dataSource = new MatTableDataSource(this.data);

    }

    ngOnDestroy() {
        // unsubscribe

    }


    selectAllGridItems(ds, isChecked: boolean) {
        // console.log(ds.data);
        // console.log(this.GridData);
        // console.log(isChecked);
        // console.log(this.GridData.length);
        this.selectAll = isChecked;
        // console.log(this.GridData.length);
        for (let x = 0; x < this.GridData.length; x++) {
            this.GridData[x].IsSelected = isChecked;
            // console.log(this.GridData[x]);
        }

        // for (let x = 0; x < this.dataSource.data[0].length; x++) {
        //     this.dataSource.data[0]. = isChecked;
        // }

        // this.dataSource.data[0].length = MatTableDataSource<this.GridData>

        // this.dataSource.data.forEach(o => {
        //     console.log(o);


        //     for (let x = 0; x < o.length; x++) {
        //         o[x].IsSelected = isChecked;
        //     }
        //   }
        //   );
    }

    selectItem(item: GenericListItem, isChecked: boolean) {
        // console.log(item);
        item.IsSelected = isChecked;

        const result = this.GridData.filter(o => o.IsSelected == false);
        if (result.length > 0) {
            this.selectAll = false;
        }
        else if (result.length == 0) {
            this.selectAll = true;
        }
    }

    checkMinAndMaxNumberOfSelected() {
        const result = this.GridData.filter(o => o.IsSelected == true);
        // console.log(result);
        // console.log('this.list.minRequiredSelected: ' + this.list.minRequiredSelected);
        // console.log('this.list.maxAllowedSelected: ' + this.list.maxAllowedSelected);
        if (this.list.maxAllowedSelected != -1 && result.length > this.list.maxAllowedSelected) {
                this.errors.push({
                    fieldName: null,
                    errorMsg: 'You may select a maximum of ' + this.list.maxAllowedSelected + ' item(s).',
                    fieldRef: null
                });
        }

        if (result.length < this.list.minRequiredSelected) {
            this.errors.push({
                fieldName: null,
                errorMsg: 'You must select at least ' + this.list.minRequiredSelected + ' item(s).',
                fieldRef: null
            });
        }


    }


    selectionChanged() {
        // this.reportParameter.isValueChange = true;

        // if (this.inDebugMode) {
        //     console.log(this.reportParameter.isValueChange);
        // }
        // if (this.reportParameter.FromPeriod > this.schoolYearSettings.MaximumPeriodsPerDay || this.reportParameter.FromPeriod < this.schoolYearSettings.MinumumPeriodPerDay) {
        //     this.reportParameter.FromPeriod = this.schoolYearSettings.MinumumPeriodPerDay;
        // }
        // if (this.reportParameter.ToPeriod > this.schoolYearSettings.MaximumPeriodsPerDay || this.reportParameter.ToPeriod < this.schoolYearSettings.MinumumPeriodPerDay) {
        //     this.reportParameter.ToPeriod = this.schoolYearSettings.MaximumPeriodsPerDay;
        // }
    }

    okClick() {
        this.checkErrors();
        if (this.errors.length == 0) {
            this.dialogRef.close(this.getSelectedIDs());
        }
    }

    getSelectedIDs(): string[] {
        const selectedIDs: string[] = [];
        for (let x = 0; x < this.GridData.length; x++) {
            if (this.GridData[x].IsSelected) {
                selectedIDs.push(this.GridData[x].Id);
            }
        }
        return selectedIDs;
    }





    checkErrors() {
        this.errors = [];
        this.checkMinAndMaxNumberOfSelected();
        // const selectedGridData = this.reportParameter.GridData.filter(o => o.Select);
        // if (selectedGridData.length == 0) {
        //     this.errors.push({
        //         fieldName: '',
        //         errorMsg: 'No Classes Have Been Selected.',
        //         fieldRef: this.select
        //     });
        // }


    }



    cancelClick() {
        this.dialogRef.close();
    }


}

